module.exports = __webpack_public_path__ + "static/media/poke.462ef8b2.jpeg";